import { render } from "./Federation.vue?vue&type=template&id=fdab729a&scoped=true"
import script from "./Federation.vue?vue&type=script&lang=js"
export * from "./Federation.vue?vue&type=script&lang=js"

import "./Federation.vue?vue&type=style&index=0&id=fdab729a&scoped=true&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdab729a"]])

export default __exports__